const getNormal = ({ x, y, z }) => {
  if (x) {
    return x > 0 ? "x" : "-x";
  }
  if (y) {
    return y > 0 ? "y" : "-y";
  }
  return z > 0 ? "z" : "-z";
};

const normalDice = {
  x: 2,
  "-x": 5,
  y: 6,
  "-y": 1,
  z: 4,
  "-z": 3,
};

export const getValueFromDice = (params) => {
  const normal = getNormal(params);

  return normalDice[normal];
};
